import Connections from '../../connections';
import {
  action, observable,
} from 'mobx';
import {
  getConfigById, getConfigs, updateConfig,
} from '../../axios/appConfigurationsReguests';
import {
  emptyConfig, IAppConfig, IAppConfigurationStore,
} from '../storeInterfaces/appConfigurationInterface';

export class AppConfigurationStore implements IAppConfigurationStore {
  @observable configurationsList: IAppConfig[] = [];

  @observable selectedConfiguration: IAppConfig = emptyConfig;

  @observable loading = false;

  @action
  public async getAppConfigurations(): Promise<any> {
    try {
      this.loading = true;
      const response = await Connections.wadiDeglaAxios.httpGet(getConfigs);
      this.configurationsList = this.structureConfigs(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async getConfigById(key: string): Promise<any> {
    try {
      this.loading = true;
      const response = await Connections.wadiDeglaAxios.httpGet(getConfigById(key));
      this.selectedConfiguration = this.restructureConfig(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async updateConfig(updatedConfig: IAppConfig, key: string): Promise<any> {
    try {
      await Connections.wadiDeglaAxios.httpPut(updateConfig(key), updatedConfig);
    } catch (error) {
      console.log(error);
    }
  }

  private structureConfigs(data: any[]): IAppConfig[] {
    const configList: IAppConfig[] = [];
    for (const config of data) {
      const configItem = {
        key: config.appConfigKey,
        value: config.value,
      };
      configList.push(configItem);
    }
    return configList;
  }

  private restructureConfig(data: any): IAppConfig {
    const configItem = {
      key: data.appConfigKey,
      value: data.value,
    };
    return configItem;
  }
}
